import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=049982be"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3276139710/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049982be')) {
      api.createRecord('049982be', component.options)
    } else {
      api.reload('049982be', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=049982be", function () {
      api.rerender('049982be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layouts/Auth.vue"
export default component.exports